import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { testHistoryStateStyles } from './styles';

export default function TestHistoryLoadingState() {
  return (
    <Box sx={testHistoryStateStyles.loadingContainer}>
      <CircularProgress size="6rem" sx={testHistoryStateStyles.loadingProgress} />
    </Box>
  );
}
